var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance"},[_c('div',{staticClass:"maintenance-box"},[_c('h1',[_vm._v("升级维护中")]),_c('p',[_vm._v("网站正在升级维护，请耐心等待...")])])])
}]

export { render, staticRenderFns }